/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Meta_TitleInputs */

const es_l6_meta_title = /** @type {(inputs: L6_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Charter — Lista 6ª con la comisión más baja`)
};

const gl_l6_meta_title = /** @type {(inputs: L6_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Charter — Lista 6ª coa comisión máis baixa`)
};

const en_l6_meta_title = /** @type {(inputs: L6_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Charter — List 6 with the lowest commission`)
};

/**
* | output |
* | --- |
* | "Zarpar · Charter — List 6 with the lowest commission" |
*
* @param {L6_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_meta_title = /** @type {((inputs?: L6_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_meta_title(inputs)
	if (locale === "en") return en_l6_meta_title(inputs)
	return es_l6_meta_title(inputs)
});